module.exports = {
      id: "pak-flag-usage",
      viewBox: "0 0 16 12",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#pak-flag",
      toString: function () {
        return this.url;
      }
    }